// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18oSV","delete":"styles_delete__pj_8-","update":"styles_update__3pRhO","add":"styles_add__1HPjh"};